import React from 'react';
import ParallaxShape from '../../components/parallax-shape/parallax-shape.js';

import './bullet-list.scss';
import shape4 from '../../assets/illustrations/shape4.svg';

const BulletList = ({ data }) => (
	<section className="bullet-list">
		<ParallaxShape
			imgPath={shape4}
			offsetYMin={-40}
			offsetYMax={40}
		/>
		<div className="container container-fluid">
			{data.content &&
			data.content.map((item, index) => (
				<div className="row" key={index}>
					<div className="col-xs-12 col-md-4 top-xs start-xs">
						{item.value.title && (
							<h2 className="title">{item.value.title}</h2>
						)}
					</div>
					<div className="col-xs-12 col-md-8 top-xs start-xs">
						<ul className="details">
							{item.value.details &&
							item.value.details.map((detail, index) => (
								<li className="detail" key={index}>
									{detail.value.image && (
										<img
											className="icon"
											src={
												process.env.REACT_APP_API_ENDPOINT +
												detail.value.image.path
											}
											alt=""
										/>
									)}
									{detail.value.name && (
										<h3 className="name">{detail.value.name}</h3>
									)}
									{detail.value.description && (
										<p className="description" dangerouslySetInnerHTML={{ __html: detail.value.description }} />
									)}
								</li>
							))}
						</ul>
					</div>
				</div>
			))}
		</div>
	</section>
);

export default BulletList;
